export const noop = (): void => {
  /*noop */
};
export function noopFn(): void {
  /*noop*/
}
